<style scoped>
    .container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
    }
    .container .dialog {
        background: #fff;
        width: 95%;
        max-width: 400px;
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-200px, -100px);
    }
    .dialog .title {
        padding: 10px;
        font-size: 16px;
        font-weight: bold;
    }
    .dialog.dialog_error > .title {
        background: #ffbbbb;
    }
    .dialog.dialog_success > .title {
        background: #bbdfa8;
    }
    .dialog .body {
        padding: 10px;
    }
    .dialog .buttons {
        text-align: center;
        padding: 1em 0;
    }
    .dialog .buttons input {
        float: none;
        margin: 0 1em;
        min-width: 7em
    }
    .clear {
        clear: both;
    }
</style>

<template>
    <div v-if="currentItem !== null" class="container">
        <div :class="`dialog dialog_${type}`">
            <div class="title">{{currentItem.title}}</div>
            <div class="body">{{currentItem.message}}</div>
            <div class="buttons">
                <input v-if="shouldShowCustomButtons" v-for="(button, index) in currentItem.buttons"
                       @click="close(button.onClickHandler)" class="popupbutton" type="button" :name="'custom-button-'+index" :value="button.title"/>
                <input v-if="!shouldShowCustomButtons"
                       @click="close()" class="popupbutton" type="button" name="closebutton" value="Close"/>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import {
        NAMESPACE as APP_NAMESPACE
    } from './../store/modules/app.js';

    export default {
        props: [''],
        data() {
            return {
                currentItem: null,
                type: null,
            };
        },
        computed: {
            shouldShowCustomButtons() {
                return !!this.currentItem.buttons && this.currentItem.buttons.length > 0;
            }
        },
        methods: {
            ...mapActions({
                registerListener: APP_NAMESPACE.actions.ADD_LISTENER
            }),
            close: function(handler) {
                this.currentItem = null;
                if (handler) {
                    handler();
                }
            }
        },
        mounted: function() {
            this.registerListener({
                on: 'MessageBox',
                handler: function(notification) {
                    this.currentItem = notification.payload || notification;
                    this.type = notification.type ?? 'error';
                }.bind(this)
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/MessageBox.vue